<div class="container">
  @if (cardField().key === conversationStartersFieldName) {
    <div
      class="content conversation-starters"
      [ngClass]="{
        truncated: !isExpanded,
        expanded: isExpanded,
      }"
    >
      @if (isExpanded) {
        <div [innerHTML]="textContent() | toNumberedList | newLineCharToHtmlLineBreak" class="text"></div>
      } @else {
        <div [textContent]="textContent() | toNumberedList" class="text text--numberedList"></div>
      }
    </div>
  } @else {
    <div
      class="content"
      [ngClass]="{
        truncated: !isExpanded,
        expanded: isExpanded,
      }"
    >
      @if (isExpanded) {
        <div [innerHTML]="formattedHtmlContent()" class="text"></div>
      } @else {
        <div [textContent]="textContent()" class="text"></div>
      }
    </div>
  }

  <a (click)="toggle()" class="link">
    {{ !isExpanded ? 'See More' : 'See Less' }}
  </a>
</div>
